import useTranslation from 'next-translate/useTranslation';
import { useMemo, useState } from 'react';

import TemplateCategoryFilter from '@/components/media/TemplateCategoryFilter';
import TemplateMasonry from '@/components/media/TemplateMasonry';

import {
  getMediaTemplateCategories,
  getMediaTemplatesByKind,
  MediaTemplateKind,
} from '@/constants/mediaTemplates';

interface MediaTemplatesSectionProps {
  kind: MediaTemplateKind;
  basePath: string;
  heading: string;
  subheading: string;
}

const MediaTemplatesSection = ({
  kind,
  basePath,
  heading,
  subheading,
}: MediaTemplatesSectionProps) => {
  const { t } = useTranslation('media-templates');
  const [category, setCategory] = useState<string | null>(null);
  const templates = useMemo(() => getMediaTemplatesByKind(kind), [kind]);
  const categories = useMemo(
    () => getMediaTemplateCategories(templates),
    [templates],
  );

  return (
    <section className='bg-white py-20 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-3xl text-center'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-100 sm:text-4xl'>
            {heading}
          </h2>
          <p className='mt-4 text-lg text-gray-600 dark:text-slate-300'>
            {subheading}
          </p>
        </div>

        <TemplateCategoryFilter
          categories={categories}
          value={category}
          onChange={setCategory}
          total={templates.length}
          className='mt-10 sm:flex-wrap sm:justify-center sm:overflow-visible'
        />

        <TemplateMasonry
          className='mt-8'
          templates={templates}
          columnsClassName='columns-2 lg:columns-3'
          getHref={(template) => `${basePath}/${template.slug}`}
          getText={(template) => ({
            title: t(template.title),
            description: t(template.description),
          })}
          ctaLabel={t('View template details')}
          isHidden={(template) =>
            Boolean(category) && template.category !== category
          }
        />
      </div>
    </section>
  );
};

export default MediaTemplatesSection;
